var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H11C10.2973 11.9998 9.60713 12.1862 9 12.54V5C9 4.46957 9.21071 3.96086 9.58579 3.58579C9.96086 3.21071 10.4696 3 11 3H12V1H11C10.4319 1.00103 9.87048 1.12308 9.35319 1.35801C8.83591 1.59294 8.37461 1.93537 8 2.3625C7.62539 1.93537 7.16409 1.59294 6.64681 1.35801C6.12952 1.12308 5.56813 1.00103 5 1H0V12C0 12.5304 0.210714 13.0391 0.585786 13.4142C0.960859 13.7893 1.46957 14 2 14H5C5.53043 14 6.03914 14.2107 6.41421 14.5858C6.78929 14.9609 7 15.4696 7 16H9C9 15.4696 9.21071 14.9609 9.58579 14.5858C9.96086 14.2107 10.4696 14 11 14H14C14.5304 14 15.0391 13.7893 15.4142 13.4142C15.7893 13.0391 16 12.5304 16 12V10H14V12ZM5 12H2V3H5C5.53043 3 6.03914 3.21071 6.41421 3.58579C6.78929 3.96086 7 4.46957 7 5V12.5375C6.39254 12.1848 5.70245 11.9993 5 12Z",
    fill: "#EBBB59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H14V4H16V0Z",
    fill: "#EBBB59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6C14.4477 6 14 6.44772 14 7C14 7.55228 14.4477 8 15 8Z",
    fill: "#EBBB59"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/book.f1a181fd7fd8257121dbf94976e3c0a8.svg";